<template>
  <div id="app">
    <!-- <img src="./assets/logo.png">
    <hello></hello>
    <a href="javascript:;" class="weui-btn weui-btn_primary">页面主操作 Normal</a>-->
    <router-view></router-view>
  </div>
</template>
<script>
import store from './vuex/store'
export default {
  store
}
</script>
<!--
<script>
import Hello from './components/Hello'

export default {
  name: 'app',
  components: {
    Hello
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
-->



// WEBPACK FOOTER //
// App.vue?0f6c384a